<template>
  <div class="row justify-content-md-center">
    <!-- Loading... -->
    <div class="loading-cover" v-if="loading">
      <div class="my-auto mx-auto text-center">
        <h2 class="waiting-text">{{ loading }}</h2>
        <zloading class="my-auto"></zloading>
      </div>
    </div>

    <Zmodalform
      v-if="done"
      :cancel-button="'Close the page'"
      @cancel-clicked="closeClicked()"
      :ok-button="''"
    >
      <div class="col-sm-12">
        <p class="waiting-text">ACH has been connected!</p>
      </div>
      <div class="col-sm-12">
        Congratulation, ACH has been connected. Now you can close the page.
      </div>
    </Zmodalform>

    <div class="col-xl-3"></div>
    <div class="col-xl-6 col-center" v-if="business">
      <section class="container-fluid white-box">
        <div class="row">
          <div class="col-md-12">
            <h2>Connect Your ACH</h2>
            <p>
              {{ business.name }}
            </p>
            <p class="sub-text">
              The page will open modal form soon...
              <br />
              If it doesn't - try to refresh the page and contact your sales
              representative.
            </p>
          </div>
        </div>
      </section>
    </div>
    <div class="col-xl-3"></div>
  </div>
</template>

<script>
import { BusinessService } from "@/services/ZdashService";
import RequestMixin from "@/mixins/RequestMixin";
import Zloading from "@/zcomponents/zloading";
import Zmodalform from "@/zcomponents/ZModalForm";

export default {
  name: "ConnectACHPage",
  props: ["businessUUID"],
  components: {
    Zmodalform,
    Zloading,
  },
  data() {
    return {
      business: undefined,
      loading: undefined,
      done: false,
    };
  },
  created() {
    this.load();
  },
  mixins: [RequestMixin],
  methods: {
    async load() {
      this.business = await this.businessService.getBusiness();
      this.loading = `Getting information for ${this.business.name}...`;
      await this.loadPlaid();
      this.openPlaid();
    },
    openPlaid() {
      const linkHandler = Plaid.create(this.plaidConfigs);
      linkHandler.open();
    },
    async loadPlaid() {
      const plaidLinkToken = await this.businessService.getPlaid();
      this.plaidConfigs = {
        token: plaidLinkToken,
        onLoad: function () {
          // The Link module finished loading.
        },
        onSuccess: this.savePlaidData,
        onExit: async function (err, metadata) {
          if (err != null) {
            this.$toast.error(metadata);
            // The user encountered a Plaid API error
            // prior to exiting.
          }
          // metadata contains information about the institution
          // that the user selected and the most recent
          // API request IDs.
          // Storing this information can be helpful for support.
        },
      };
      // eslint-disable-next-line no-undef
    },
    async savePlaidData(publicToken, metadata) {
      this.loading = "Almost done! Connecting ACH...";
      const request = this.businessService.savePlaid({
        public_token: publicToken,
        account_id: metadata.accounts[0].id,
      });
      if (!(await this._executeRequest(request))) {
        this.loading = undefined;
        return;
      }
      this.loading = undefined;
      this.done = true;
    },
    closeClicked() {
      window.close();
    },
  },
  computed: {
    businessService() {
      return new BusinessService(this.businessUUID);
    },
  },
};
</script>

<style scoped></style>
